import { getDataMapper, mapField } from "@/shared";

export const mapAuthDataToServer = getDataMapper({
    login: mapField("login"),
    password: mapField("password"),
});
